'use client';

import { fetchSeedingItemDetail, fetchSeedingItemsByShopSkus } from '@/api/marketingPages';
import type {
  SeedingItemDetailResponse,
  SeedingItemsResponse,
} from '@/app/(activity)/campaigns/[slug]/types';
import useSWR from 'swr';

const SWR_OPTIONS = {
  dedupingInterval: 300_000,
  revalidateIfStale: false,
  revalidateOnFocus: false,
} as const;

type SummaryKey = readonly ['material-gallery-summary', number, boolean, readonly string[]];
type DetailKey = readonly ['material-gallery-detail', number, number, boolean];

const fetchSummary = ([, marketingPageId, isPreview, shopSkus]: SummaryKey) =>
  fetchSeedingItemsByShopSkus(marketingPageId, shopSkus, isPreview);

const fetchDetail = ([, marketingPageId, itemId, isPreview]: DetailKey) =>
  fetchSeedingItemDetail(itemId, marketingPageId, isPreview);

export function useMaterialGallerySummary(
  marketingPageId: number,
  shopSkus: readonly string[],
  isPreview: boolean,
  enabled: boolean,
) {
  return useSWR<SeedingItemsResponse, Error, SummaryKey>(
    enabled && marketingPageId > 0 && shopSkus.length > 0
      ? ['material-gallery-summary', marketingPageId, isPreview, shopSkus]
      : null,
    fetchSummary,
    SWR_OPTIONS,
  );
}

export function useMaterialGalleryDetail(
  marketingPageId: number,
  itemId: number | null,
  isPreview: boolean,
) {
  return useSWR<SeedingItemDetailResponse, Error, DetailKey>(
    marketingPageId > 0 && itemId && itemId > 0
      ? ['material-gallery-detail', marketingPageId, itemId, isPreview]
      : null,
    fetchDetail,
    SWR_OPTIONS,
  );
}
